// extracted by mini-css-extract-plugin
module.exports = {"HeaderSingglePage":"HeaderSingglePage_HeaderSingglePage__23uzl","wrapper":"HeaderSingglePage_wrapper__2-qqM"};